import React from 'react';
import TodoGamesList from '../Components/TodoGamesList';

const TodoGames = () => {
  return (
    <div>
      <TodoGamesList />
    </div>
  );
};

export default TodoGames;
